import React from 'react';
import { Col, Row, Card } from 'reactstrap';
import { Input } from 'react-ocean-forms-bootstrap';
import { FieldGroup, validators } from 'react-ocean-forms';
import { PermissionComponent } from '../../Common/PermissionComponent';
import { ViewConfigInterface } from '../../viewConfig.types';

interface RequestInfoFormProps {
  name: string;
  label?: string;
  disabled?: boolean;
  viewConfig: ViewConfigInterface;
}

/**
 * @author Jungwirth
 */
export const RequestInfoForm: React.FC<RequestInfoFormProps> = (props: Readonly<RequestInfoFormProps>): JSX.Element => {
  const { name, label, disabled, viewConfig } = props;

  const renderRequestInfos = (): JSX.Element => {
    return (
      <React.Fragment>
        <Card body className="mb-2 border-0">
          <Row>
            <Col md={6}>
              <PermissionComponent
                permission={viewConfig.email.permissions}>
                <Input
                  name="email"
                  label="email_requester"
                  {...viewConfig.email.field}
                  disabled={disabled || viewConfig.email.field.disabled}
                />
              </PermissionComponent>
            </Col>
          </Row>
          <Row>
            <Col>
              <PermissionComponent
                permission={viewConfig.zweckOderQuelle.permissions}>
                <Input
                  type="textarea"
                  name="zweckOderQuelle"
                  label="usage_source"
                  {...viewConfig.zweckOderQuelle.field}
                  disabled={disabled || viewConfig.zweckOderQuelle.field.disabled}
                />
              </PermissionComponent>
            </Col>
            <Col>
              <PermissionComponent
                permission={viewConfig.anmerkung.permissions}>
                <Input
                  type="textarea"
                  name="anmerkung"
                  label="annotation"
                  {...viewConfig.anmerkung.field}
                  disabled={disabled || viewConfig.anmerkung.field.disabled}
                />
              </PermissionComponent>
            </Col>
          </Row>
        </Card>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <FieldGroup
        name={name}
        label={label ? label : ''}
        render={renderRequestInfos}
      >
      </FieldGroup>
    </React.Fragment>
  );
};
